<template>
  <div>
    <div class="risk-type">
      <div class="risk-type-box">
        <div class="module-title">
          <div class="title-box">
            隐患整改详情
          </div>
        </div>
        <div class="hidden-bg"></div>
        <hidden-danger-handle-ring
          v-if="infoData.troubleInfo"
          :echartsData="infoData.troubleInfo"
        ></hidden-danger-handle-ring>
        <div class="triple">
          <div
            class="triple-first"
            title="点击查看隐患总数"
            @click="checkHiddenDanger(infoData.troubleInfo.total, 0)"
          >
            <div class="triple-num">
              {{ infoData.troubleInfo.total }}
            </div>
            <div class="triple-name">隐患总数</div>
          </div>
          <div
            class="triple-second"
            title="点击查看未处理隐患"
            @click="checkHiddenDanger(infoData.troubleInfo.untreated, 1)"
          >
            <div class="triple-num">
              {{ infoData.troubleInfo.untreated }}
            </div>
            <div class="triple-name">未处理隐患总数</div>
          </div>
          <div
            class="triple-third"
            title="点击查看已验收隐患"
            @click="checkHiddenDanger(infoData.troubleInfo.accepted, 4)"
          >
            <div class="triple-num">
              {{ infoData.troubleInfo.accepted }}
            </div>
            <div class="triple-name">已验收隐患总数</div>
          </div>
        </div>
      </div>
    </div>
    <div class="school-List">
      <school-list
        :schoolList="infoData.schoolList"
        @clickRow="clickRow"
        ref="schoolList"
        type='hiddenDanger'
      ></school-list>
    </div>
    <div class="unsafe-type-title">
      <module-title title="发现隐患分类占比"></module-title>
    </div>
    <div class="unsafe-type-content">
      <hidden-danger-pie
        type="h"
        v-if="infoData.dangerDynamicTypes"
        :echartsData="infoData.dangerDynamicTypes"
      ></hidden-danger-pie>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <div class="four-color-title">
      <module-title title="区域隐患统计"></module-title>
    </div>
    <div class="four-color-module">
      <hidden-danger-line
        v-if="infoData.troubleStatistics"
        :echartsData="infoData.troubleStatistics"
      >
      </hidden-danger-line>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <hidden-danger-dialog
      :showCount="showCount"
      :searchParams="searchParams"
    ></hidden-danger-dialog>
  </div>
</template>
<script>
import hiddenDangerHandleRing from "./hiddenDangerHandleRing";
import hiddenDangerDialog from "./hiddenDangerDialog";
import hiddenDangerPie from "./hiddenDangerPie";
import hiddenDangerLine from "./hiddenDangerLine";
import schoolList from "./schoolList";
import moduleTitle from "./moduleTitle";
export default {
  name: "hiddenDangerStatistics",
  props: {
    infoData: {
      type: Object,
      default: {
        return: {}
      }
    },
    searchParams: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  components: {
    hiddenDangerHandleRing,
    hiddenDangerDialog,
    hiddenDangerPie,
    hiddenDangerLine,
    schoolList,
    moduleTitle
  },
  data() {
    return {
      riskListShow: false,
      showCount: 0
    };
  },
  methods: {
    clickRow(info) {
      this.$emit("clickRow", info);
    },
    dialogClose() {
      this.riskListShow = false;
    },
    checkHiddenDanger(num, type) {
      if (num > 0) {
        this.searchParams.status = type;
        this.showCount++;
      } else {
        this.$message({ message: "暂无数据", type: "warning", duration: 1000 });
      }
    }
  },
  computed: {
    levelNames() {
      return this.$store.state.select.riskLevel.map((item) => {
        return item.levelNameOne;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.risk-type {
  position: absolute;
  top: 80px;
  left: 90px;
  width: 440px;
  height: 300px;
  display: flex;
  justify-content: center;
  .module-title {
    height: 40px;
    width: 220px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .title-box {
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgb(203, 224, 255);
    }
  }
  .risk-type-box {
    width: 100%;
    height: 100%;
    background: url("~@/assets/img/bigDataCollge/chart-view-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
    .risk-leve-chart {
      height: 250px;
      padding: 0 10px;
    }
    .hidden-bg {
      position: absolute;
      //   background-color: rgb(24, 24, 107);
      top: 50px;
      left: 20px;
      width: 400px;
      height: 230px;
    }
    .triple {
      width: 400px;
      height: 156px;
      display: flex;
      justify-content: space-between;
      background: url("~@/assets/img/schoolBigData/triple-bg-two.gif") center
        center no-repeat;
      background-size: 100% 100%;
      position: relative;
      left: 20px;
      top: -112px;
      text-align: center;
    }
    .triple-first {
      height: 64px;
      cursor: pointer;
      position: relative;
      left: 28px;
      top: 26px;
      z-index: 10;
      .triple-num {
        color: #c23c33;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .triple-name {
        color: #c23c33;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
    .triple-second {
      height: 64px;
      cursor: pointer;
      position: relative;
      left: 18px;
      top: 82px;
      z-index: 10;
      .triple-num {
        color: #eca800;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .triple-name {
        color: #eca800;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
    .triple-third {
      height: 64px;
      cursor: pointer;
      position: relative;
      left: -8px;
      top: 26px;
      z-index: 10;
      .triple-num {
        color: #51a6fe;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .triple-name {
        color: #51a6fe;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
  }
}
.school-List {
  width: 440px;
  height: 500px;
  position: absolute;
  top: 400px;
  left: 90px;
}
.unsafe-type-title {
  position: absolute;
  top: 600px;
  left: 560px;
}
.unsafe-type-content {
  position: absolute;
  top: 640px;
  left: 560px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center
    center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.four-color-title {
  position: absolute;
  top: 600px;
  left: 990px;
}
.four-color-module {
  position: absolute;
  top: 640px;
  left: 990px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center
    center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
</style>
